import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { CoreData } from "src/app/tools/core-data/core-data";
import { LoadingTask } from "src/app/tools/ui/loading-task";
import { environment } from "src/environments/environment";
import { AreaMap } from "../domain/area-map";
import { BaseService } from "./base.service";
import { AreaMapDTO } from "./dto/area-map.dto";

@Injectable({
    providedIn: 'root',
})
export class AreaMapService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/areamap`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getAreaMapListByIntervention(interventionCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/intervention/${interventionCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAreaMapListByIntervention')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: AreaMapDTO[]) => {
                return response.map((item: AreaMapDTO) => {
                    return AreaMap.mapFromJSON(item);
                });
            }));
    }

    getAreaMapById(areaMapId: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${areaMapId}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAreaMapbyId')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: AreaMapDTO) => {
                return AreaMap.mapFromJSON(response);
            }));
    }

    updateAreaMap(areaMap: AreaMap, file: File) {
        const formData: FormData = new FormData();

        // formData.append('legend', areaMap.Legend ? areaMap.Legend : '');
        // formData.append('comment', areaMap.Comment ? areaMap.Comment : '');
        // if (areaMap.BackgroundPictureElectronicDocumentId) {
        //     formData.append('BackgroundPictureElectronicDocumentId', `${areaMap.BackgroundPictureElectronicDocumentId}`);
        // }
        formData.append('jsonContent', areaMap.JsonContent!);
        if (file) {
            formData.append('picture', file, file.name);
        }

        return this.http.request(new HttpRequest('PUT', this.serviceUrl + `/${areaMap.Id}`, formData, this.generateHeaderForFormData()));
    }
}